import { render, staticRenderFns } from "./new-footer.vue?vue&type=template&id=5a68406d&scoped=true"
var script = {}
import style0 from "./new-footer.vue?vue&type=style&index=0&id=5a68406d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a68406d",
  null
  
)

export default component.exports